import 'css-chunksrc/client/pages/accountCreationConfirmationPage/styles.scss';export default {
  "accountCreationConfirmationPage": "_accountCreationConfirmationPage_1xemk_1",
  "header": "_header_1xemk_8",
  "logoBox": "_logoBox_1xemk_14",
  "logo": "_logo_1xemk_14",
  "main": "_main_1xemk_22",
  "accountCreationConfirmation": "_accountCreationConfirmation_1xemk_1"
};